import omit from 'lodash/omit';
import { apiSlice } from '../../../app/services/apiSlice';
import { PRODUCT_TYPES, PRODUCT_TYPES_CUSTOM } from '../utils';

const SOURCE_URL = 'products';
const COMPANY_URL = 'company';

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    addNewSource: builder.mutation({
      query: (data) => ({
        url: `${SOURCE_URL}/apply-sources`,
        method: 'POST',
        body: {
          ...data,
        },
      }),
    }),
    updateSource: builder.mutation({
      query: (data) => ({
        url: `${SOURCE_URL}/apply-sources/${data?.id}`,
        method: 'PUT',
        body: omit(data,'id')
      }),
    }),

    getAllSources: builder.query({
      query: (params) => ({
        url: `${COMPANY_URL}/company-products`,
        params,
      }),
    }),

    getAllSourceDetails: builder.mutation({
      query: () => ({
        url: `${COMPANY_URL}/company-products`,
        method: 'GET',
        params: {productType: [PRODUCT_TYPES.CLIENT_APPLY_SOURCE, PRODUCT_TYPES.AGENCY]}
      }),
    }),

    getSources: builder.mutation({
      query: (params) => ({
        url: `${COMPANY_URL}/private/company-products`,
        method: 'GET',
        params: {...params,sort:'title',sortDir:'ASC',perPage:50, productType: PRODUCT_TYPES.CLIENT_APPLY_SOURCE, visibility:'PRIVATE'}
      }),
      transformResponse: (responseData) => {
        responseData.options = responseData?.advertising?.map((source) => ({
          ...source,
          title: source?.title,
          value: source?.accessKey,
        }));
        return responseData || {};
      },
    }),
    getSourcesAsyncSelect: builder.mutation({
      query: (params) => ({
        url: `${COMPANY_URL}/company-products`,
        method: 'GET',
        params: {...params,sort:'title',sortDir:'ASC',perPage:50, productType: PRODUCT_TYPES.CLIENT_APPLY_SOURCE}
      }),
      transformResponse: (responseData) => {
        responseData.options = responseData?.advertising?.filter(source=>source?.productType===PRODUCT_TYPES.CLIENT_APPLY_SOURCE)?.map((source) => ({
          ...source,
          title: source?.title,
          value: source?.accessKey,
        }));
        return responseData || {};
      },
    }),
    getCandSourcesAsyncSelect: builder.mutation({
      query: (params) => ({
        url: `${COMPANY_URL}/company-products`,
        method: 'GET',
        params: {...params,sort:'title',sortDir:'ASC',perPage:50,visibilityType:[PRODUCT_TYPES_CUSTOM.INTERNAL], productType: [PRODUCT_TYPES.CLIENT_APPLY_SOURCE,PRODUCT_TYPES_CUSTOM.ADVERTISING]}
      }),
      transformResponse: (responseData) => {
        responseData.options = responseData?.advertising?.map((source) => ({
          ...source,
          title: source?.title,
          value: source?.accessKey,
        }));
        return responseData || {};
      },
    }),
    deleteCandidateSource: builder.mutation({
      query: (params) => ({
        url: `${SOURCE_URL}/apply-sources/${params}`,
        method: 'DELETE',
      }),
    }),
    getCompanyCandidateSources: builder.query({
      query: (params) => ({
        url: `${COMPANY_URL}/private/company-products`,
        params,
      }),
    }),
  }),
});

export const {
  useAddNewSourceMutation,
  useUpdateSourceMutation,
  useGetAllSourcesQuery,
  useDeleteCandidateSourceMutation,
  useGetSourcesMutation,
  useGetSourcesAsyncSelectMutation,
  useGetAllSourceDetailsMutation,
  useGetCompanyCandidateSourcesQuery,
  useGetCandSourcesAsyncSelectMutation,
} = extendedApiSlice;
